import { Link } from "react-router";

import { ArchiveItem } from "models/ArchiveItem";
import Time from "common/Time";
import config from "config/config";
import { getTabToken } from "common/MetaActions";
import { downloadAndSaveFile } from "common/downloadFile";

import "./ArchivePreviewItem.scss";

type Props = {
  document: ArchiveItem;
  customerId: string;
};

export default function ArchivePreviewItem({ document, customerId }: Props) {
  const triggerDownload = (
    e: React.MouseEvent<HTMLSpanElement, MouseEvent>
  ) => {
    e.preventDefault();

    const url = config.api.archive.download(customerId, document.id);
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${getTabToken()}`);
    downloadAndSaveFile(url, document.name, headers);
  };

  return (
    <li className="archivePreviewDoc">
      <div className="elements">
        <div>
          <span className="file" onClick={(e) => triggerDownload(e)}>
            {document.name}
          </span>{" "}
          publicerades <br />
        </div>
        <div>
          <Link
            to={
              "/archive?folderId=" +
              document.path +
              "&fileId=" +
              encodeURIComponent(document.id)
            }
          >
            {" "}
            Visa fil i dokumentarkivet
          </Link>
        </div>
      </div>
      <time>{Time.formatShort(document.createdAt)}</time>
    </li>
  );
}
